import { Dropdown } from '../Dropdown/Dropdown';

/**
 * returns JSX for year select dropdown
 */
function YearSelect({
  value = '',
  onChange,
  options,
}: {
  value: string;
  onChange: (t: string) => void;
  options: string[];
}) {
  const items = options
    .map((year) => ({
      label: year,
      key: year,
    }))
    .map((item) => ({
      ...item,
      onClick: () => onChange(item.key),
    }));
  const findValues = items.find(({ key }) => key === value);
  return (
    <Dropdown
      label={findValues?.label || 'Select year'}
      menu={{ items }}
      key={value}
      className="secondary"
    />
  );
}

export default YearSelect;
